import React from 'react';

const Step5Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-5">
            Richiedi subito il tuo preventivo online con la detrazione fiscale
            fino al 50%.
        </div>
    );
};

export default Step5Infos;
